import React, { useState, useEffect } from 'react';
import {
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
  Stack,
  Alert,
  alpha,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Swal from 'sweetalert2';
import { Modal } from '../components/BootstrapToMUI';
import request from '../services/Request';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CheckIcon from '@mui/icons-material/Check';

export default function PlanoModal(props) {
  const theme = useTheme();

  const getPlanoByEmailURL = `/plano/getPlanoByEmail/`;
  const updateMachineURL = `/machines/updatePlano`;
  const { rowData, showAdmin, machines, setRowData, setMachines, ...rest } = props;

  const [planos, setPlanos] = useState([]);
  const [planoid, setplanoid] = useState('');
  const [planoErr, setPlanoErr] = useState('');
  const [subplano, setsubplano] = useState([]);
  const [dis, setdis] = useState(true);

  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (props.show) {
      console.log('beforeupdate', machines);
      console.log('beforeupdate', rowData);
      if (planoid != '') {
        setsubplano(
          rowData && rowData.length > 0
            ? planos.filter((e) => e.referPlano == rowData[0].plano)
            : []
        );
      } else {
        setsubplano([]);
      }
    }
  }, [planos]);

  useEffect(() => {
    if (props.show) {
      setIsReady(false);
      let isCancelled = false;
      const belongTo =
        rowData && rowData.length > 0 ? (rowData[0].belongTo ? rowData[0].belongTo : '') : '';
      if (belongTo != '') {
        setplanoid(rowData && rowData.length > 0 ? (rowData[0].plano ? rowData[0].plano : '') : '');
        setPlanoErr('');
        //getAllEmployees
        async function getPlanos() {
          request({
            method: 'get',
            url: getPlanoByEmailURL + belongTo,
          })
            .then((res) => {
              if (!isCancelled) {
                setPlanos(res.data);
                let go = true;
                res.data.forEach((m) => {
                  const mymodel =
                    m.model.indexOf('(') > -1
                      ? m.model.slice(0, m.model.indexOf('(')).trim()
                      : m.model;
                  // console.log('rowData[0].model', rowData[0].model);
                  // console.log('mymodel', mymodel);
                  if (mymodel == rowData[0].model) {
                    go = false;
                  }
                });
                setdis(go);
                setIsReady(true);
              }
            })
            .catch((err) => {
              setPlanoErr('Failed to get planogram');
              setIsReady(true);
            });
        }

        getPlanos();

        return () => {
          setplanoid('');
          setPlanoErr('');
          setPlanos([]);
          setsubplano([]);
          setdis(true);
          isCancelled = true;
        };
      }
    }
  }, [props.show]);

  const onSubmit = async () => {
    // console.log('planoid', planoid);
    // return console.log('rowData_Original', rowData);

    // console.log('planos', planos);
    // console.log(planoid);
    // console.log(planos[index].model);
    if (showAdmin) {
      let machineID = rowData.map((e) => e._id);
      request({
        method: 'patch',
        url: updateMachineURL,
        data: {
          plano: planoid,
          machineID: machineID,
          model: rowData[0].model,
        },
      })
        .then((res) => {
          setPlanoErr('');
          //change local state
          //map all rowData's id

          setMachines((prevMachines) =>
            prevMachines.map((e) => (machineID.includes(e._id) ? { ...e, plano: planoid } : e))
          );
          setRowData((prevRowData) =>
            prevRowData.map((e) => ({
              ...e,
              plano: planoid,
            }))
          );

          Swal.fire({
            text: `The planogram has been selected`,
            icon: 'success',
          }).then(() => {
            props.onHide();
          });
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status === 406) {
              setPlanoErr(err.response.data.message);
            }
          }
        });
    } else {
      Swal.fire({
        text: `You have no permission to change the planogram`,
        icon: 'error',
      });
    }
  };

  const handleChange = async (event) => {
    setPlanoErr('');
    setplanoid(event.target.value);
    const subp = planos.filter((e) => e.referPlano == event.target.value);
    setsubplano([...subp]);
  };

  return (
    <Modal {...rest} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            Select Your Planogram
          </Typography>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Box sx={{ p: 3 }}>
          <Stack spacing={3}>
            {/* Main Planogram Selection */}
            <Box
              sx={{
                p: 3,
                borderRadius: 3,
                background: alpha(theme.palette.primary.main, 0.05),
                border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              }}
            >
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="flex-start">
                <Box sx={{ flex: 1, width: '100%' }}>
                  {dis ? (
                    <FormControl fullWidth>
                      <InputLabel id="select-plano">No Available Planograms</InputLabel>
                      <Select
                        labelId="select-plano"
                        id="select-plano"
                        value=""
                        disabled
                        label="No Available Planograms"
                        sx={{
                          borderRadius: 2,
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: alpha(theme.palette.divider, 0.2),
                          },
                        }}
                      />
                    </FormControl>
                  ) : (
                    <FormControl fullWidth>
                      <InputLabel id="select-plano">Select Planogram</InputLabel>
                      <Select
                        labelId="select-plano"
                        id="select-plano"
                        value={planoid}
                        disabled={dis}
                        onChange={handleChange}
                        label="Select Planogram"
                        sx={{
                          borderRadius: 2,
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: alpha(theme.palette.primary.main, 0.3),
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: theme.palette.primary.main,
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: theme.palette.primary.main,
                            borderWidth: 2,
                          },
                        }}
                      >
                        {planos.map((m) => {
                          const mymodel =
                            m.model.indexOf('(') > -1
                              ? m.model.slice(0, m.model.indexOf('(')).trim()
                              : m.model;

                          if (m.referPlano == null && mymodel == rowData[0].model) {
                            return (
                              <MenuItem key={m._id} value={m._id}>
                                {m.name}
                              </MenuItem>
                            );
                          }
                        })}
                      </Select>
                    </FormControl>
                  )}

                  {planoErr != '' && (
                    <Alert severity="error" sx={{ mt: 2, borderRadius: 2 }}>
                      {planoErr}
                    </Alert>
                  )}
                </Box>
                <Button
                  disabled={planoid == ''}
                  onClick={() => {
                    if (rowData[0].model.includes('Gamma')) {
                      window.open(`/TCNplano/${planoid}/${rowData[0].belongTo}`, 'planogram');
                    } else if (rowData[0].model.includes('Inspire')) {
                      window.open(`/INSplano/${planoid}/${rowData[0].belongTo}`, 'planogram');
                    } else if (rowData[0].model.includes('Delta')) {
                      window.open(`/DELplano/${planoid}/${rowData[0].belongTo}`, 'planogram');
                    } else if (rowData[0].model.includes('SmartBox')) {
                      window.open(`/SMBplano/${planoid}/${rowData[0].belongTo}`, 'planogram');
                    } else {
                      window.open(`/plano/${planoid}/${rowData[0].belongTo}`, 'planogram');
                    }
                  }}
                  variant="outlined"
                  startIcon={<VisibilityIcon />}
                  sx={{
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                    px: 3,
                    py: 1.5,
                    minWidth: 180,
                    borderWidth: 1.5,
                    '&:hover': {
                      borderWidth: 1.5,
                      backgroundColor: alpha(theme.palette.primary.main, 0.08),
                    },
                  }}
                >
                  Show Planogram
                </Button>
              </Stack>
            </Box>

            {/* Sub Planograms */}
            {subplano &&
              subplano.map((e, index) => {
                return (
                  <Box
                    key={index}
                    sx={{
                      p: 3,
                      borderRadius: 3,
                      background: alpha(theme.palette.secondary.main, 0.05),
                      border: `1px solid ${alpha(theme.palette.secondary.main, 0.2)}`,
                    }}
                  >
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="body1" sx={{ fontWeight: 600, fontSize: '1rem' }}>
                          {e.name}
                        </Typography>
                      </Box>
                      <Button
                        onClick={() => {
                          if (rowData[0].model.includes('Gamma')) {
                            window.open(`/TCNplano/${e._id}/${rowData[0].belongTo}`, 'planogram');
                          } else if (rowData[0].model.includes('Inspire')) {
                            window.open(`/INSplano/${e._id}/${rowData[0].belongTo}`, 'planogram');
                          } else if (rowData[0].model.includes('Delta')) {
                            window.open(`/DELplano/${e._id}/${rowData[0].belongTo}`, 'planogram');
                          } else if (rowData[0].model.includes('SmartBox')) {
                            window.open(`/SMBplano/${e._id}/${rowData[0].belongTo}`, 'planogram');
                          } else {
                            window.open(`/plano/${e._id}/${rowData[0].belongTo}`, 'planogram');
                          }
                        }}
                        variant="outlined"
                        color="secondary"
                        startIcon={<VisibilityIcon />}
                        sx={{
                          borderRadius: 2,
                          textTransform: 'none',
                          fontWeight: 600,
                          px: 3,
                          py: 1.5,
                          minWidth: 180,
                          borderWidth: 1.5,
                          '&:hover': {
                            borderWidth: 1.5,
                            backgroundColor: alpha(theme.palette.secondary.main, 0.08),
                          },
                        }}
                      >
                        Show Planogram
                      </Button>
                    </Stack>
                  </Box>
                );
              })}

            {/* Select Button */}
            <Button
              fullWidth
              onClick={onSubmit}
              disabled={planoid == '' || !isReady}
              variant="contained"
              startIcon={<CheckIcon />}
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 700,
                py: 1.5,
                fontSize: '1rem',
                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.4)}`,
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.5)}`,
                },
                '&:disabled': {
                  background: alpha(theme.palette.action.disabled, 0.12),
                  color: theme.palette.action.disabled,
                },
                transition: 'all 0.3s ease',
              }}
            >
              Select Planogram
            </Button>
          </Stack>
        </Box>
      </Modal.Body>
    </Modal>
  );
}
